import VideoPlaylistCard from './video-playlist-card'

export type { VideoPlaylistCardProps } from './video-playlist-card'

export default VideoPlaylistCard
